// Copyright (c) 2025 Deere & Company

import React, {PropTypes} from 'react';
import AmountOfUseModalBody from './amount-of-use-update-modal-body';
import AmountOfUseUpdateModalHeader from './amount-of-use-update-modal-header';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import TcsmApproveDenyModal from '../../state/tcsm-approve-deny-modal';
import {WarrantyMediumModal} from '../../../../shared/components/modal';

const AmountOfUseUpdateModal = props =>
    <section className='machine-status-update-modal'>
        <WarrantyMediumModal isOpen={props.amountOfUseModal.isVisible}>
            <AmountOfUseUpdateModalHeader
                amountOfUseModalAction={props.amountOfUseModal.actionToTake}
                closeUpdateAmountOfUseModal={props.closeUpdateAmountOfUseModal}

            />
            <AmountOfUseModalBody
                amountOfUseModalAction={props.amountOfUseModal.actionToTake}
                amountOfUseRequestItemToUpdate={props.amountOfUseRequestItemToUpdate}
                onCommentsToDealerChange={props.onCommentsToDealerChange}
                onConfirmation={props.onConfirmation}
                onInternalDeereCommentsChange={props.onInternalDeereCommentsChange}
            />
        </WarrantyMediumModal>
    </section>;

AmountOfUseUpdateModal.displayName = 'AmountOfUseUpdateModal';
AmountOfUseUpdateModal.propTypes = {
    amountOfUseModal: PropTypes.instanceOf(TcsmApproveDenyModal).isRequired,
    amountOfUseRequestItemToUpdate: PropTypes.instanceOf(MeasurementReading).isRequired,
    closeUpdateAmountOfUseModal: PropTypes.func.isRequired,
    onCommentsToDealerChange: PropTypes.func.isRequired,
    onConfirmation: PropTypes.func.isRequired,
    onInternalDeereCommentsChange: PropTypes.func.isRequired
};

export default AmountOfUseUpdateModal;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/update-amount-of-use/update-amount-of-use-modal.js